<template>
    <FormRoot>
        <p class="mb-4">
            Passing status from <strong>{{ request.status.name }}</strong> to <strong>{{ status }}</strong> for expense
            request of <strong>{{ request.user.name }}</strong>
            <template v-if="request.partner"
                >at partner <strong>{{ request.partner.name[$store.state.lang.displayLanguage] }}</strong></template
            >
            for an amount of <strong>{{ request.amount | currency }}</strong> created on
            <strong>{{ request.created_at | formatDate }}</strong
            >.
        </p>
        <div class="mb-2">
            <Button
                color="light"
                small
                v-for="(answer, index) in answers"
                class="text-truncate mb-1 me-1"
                style="max-width: 200px"
                :key="index"
                icon="align-left"
                @click="setReason(answer)"
                >{{ answer[request.user.locale] }}</Button
            >
        </div>
        <Field
            :form.sync="form"
            type="textarea"
            :maxLength="400"
            name="reason"
            hint="Explanation of the status for the user"
        />
        <FormActions>
            <Submit class="float-right" :disabled="!form.submittable" :loading="form.loading" @click="onSubmit"
                >Set status</Submit
            >
        </FormActions>
    </FormRoot>
</template>

<script>
    import { FormRoot, Field, FormActions, Submit, Button } from '@tech_hexeko/design-system'
    import Forms from '@/mixins/Forms'
    import answers from './answers'

    export default {
        props: {
            request: {
                type: Object,
                required: true,
            },
            status: {
                type: String,
                required: true,
                validator: (value) => {
                    return ['decline', 'needRectification'].indexOf(value) > -1
                },
            },
        },
        data() {
            return {
                answers: answers,
                /** @public - used by Forms mixin */
                fields: {
                    reason: null,
                },
                /** @public - used by Forms mixin */
                messageSuccess: 'The status has been set',
            }
        },
        mixins: [Forms],
        components: {
            FormRoot,
            FormActions,
            Submit,
            Field,
            Button,
        },
        methods: {
            setReason(answer) {
                this.form.reason = answer[this.request.user.locale]
            },
            /** @public - used by Forms mixin */
            submit() {
                if (this.status === 'decline') {
                    return this.$api.expenseRequests.decline(this.request.id, this.$data.form.data())
                } else if (this.status === 'needRectification') {
                    return this.$api.expenseRequests.needRectification(this.request.id, this.$data.form.data())
                }
            },
        },
    }
</script>
